import { render, staticRenderFns } from "./QuoteEdit.vue?vue&type=template&id=1dffd814&scoped=true&"
import script from "./QuoteEdit.vue?vue&type=script&lang=js&"
export * from "./QuoteEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuoteEdit.vue?vue&type=style&index=0&id=1dffd814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dffd814",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})
